import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../config";
import cogoToast from "cogo-toast";

// ================================================================= GET ALL CARDS BY USER
export const getCardsByUser = createAsyncThunk(
  "getCardsByUser",
  async (args, { rejectWithValue, dispatch, getState }) => {
    const id = getState().auth.user.user_id;
    try {
      const res = await axios.get(`${baseUrl}/virtual-card/user/${id}?page=1&page_size=10`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": getState().auth.token.toString(),
        },
      });
      if (res.status === 200) {
        console.log(res);
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.response);
      }
    }
  }
); 

// ================================================================= GET ALL CARDS BY USER
export const getCardsByID = createAsyncThunk(
    "getCardsByID",
    async ({cardId}, { rejectWithValue, dispatch, getState }) => {
      try {
        const res = await axios.get(`${baseUrl}/virtual-card/${cardId}`, {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        });
        if (res.status === 200) {
          console.log(res);
          return res.data;
        }
      } catch (error) {
        if (error.response.status === 401) {
          dispatch({ type: "auth/Logout" });
          return rejectWithValue(error.response);
        } else {
          return rejectWithValue(error.response);
        }
      }
    }
  ); 

// ======================================== CREATE A CARD
export const createVirtualCard = createAsyncThunk(
    "createVirtualCard",
    async ({brand, amount, debitWalletId}, { rejectWithValue, dispatch, getState }) => {
      const id = getState().auth.user.user_id;
      try {
        const res = await axios.post(
          `${baseUrl}/virtual-card/create/${id}`,
          {
            brand: brand,
            amount: amount,
            debitWalletId: debitWalletId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": getState().auth.token.toString(),
            },
          }
        );
        if (res.status === 200 || res.status === 201) {
          console.log(res);
          cogoToast.success("Your request has been received and your card is now been processed!");
          return res.data;
        }
      } catch (error) {
         if (error.response.status === 401) {
          dispatch({ type: "auth/logout" });
          return rejectWithValue(error.response);
        } else if (error.response.status === 410) {
          cogoToast.error(`${error.response.data.message}`);
          return rejectWithValue(error.response);
        } else {
          cogoToast.error(`${error.response.data.message}`);
          return rejectWithValue(error.response);
        }
      }
    }
  );

  // ======================================== FUND A CARD
export const fundVirtualCard = createAsyncThunk(
    "fundVirtualCard",
    async ({cardId, amount, debitWalletId}, { rejectWithValue, dispatch, getState }) => {
      const id = getState().auth.user.user_id;
      try {
        const res = await axios.post(
          `${baseUrl}/virtual-card/fund/${id}`,
          {
            cardId: cardId,
            amount: amount,
            debitWalletId: debitWalletId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": getState().auth.token.toString(),
            },
          }
        );
        if (res.status === 200 || res.status === 201) {
          console.log(res);
          cogoToast.success("Card funding is successful.");
          return res.data;
        }
      } catch (error) {
         if (error.response.status === 401) {
          dispatch({ type: "auth/logout" });
          return rejectWithValue(error.response);
        } else if (error.response.status === 410) {
          cogoToast.error(`${error.response.data.message}`);
          return rejectWithValue(error.response);
        } else {
          cogoToast.error(`${error.response.data.message}`);
          return rejectWithValue(error.response);
        }
      }
    }
  );

  // ======================================== WITHDRAW FROM A CARD
  export const withdrawFromVirtualCard = createAsyncThunk(
    "withdrawFromVirtualCard",
    async ({cardId, amount, creditWalletId}, { rejectWithValue, dispatch, getState }) => {
      const id = getState().auth.user.user_id;
      try {
        const res = await axios.post(
          `${baseUrl}/virtual-card/withdraw/${id}`,
          {
            cardId: cardId,
            amount: amount,
            creditWalletId: creditWalletId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": getState().auth.token.toString(),
            },
          }
        );
        if (res.status === 200 || res.status === 201) {
          console.log(res);
          cogoToast.success("Card withdrawal successful.");
          return res.data;
        }
      } catch (error) {
         if (error.response.status === 401) {
          dispatch({ type: "auth/logout" });
          return rejectWithValue(error.response);
        } else if (error.response.status === 410) {
          cogoToast.error(`${error.response.data.message}`);
          return rejectWithValue(error.response);
        } else {
          cogoToast.error(`${error.response.data.message}`);
          return rejectWithValue(error.response);
        }
      }
    }
  );  

    // ======================================== FREEZE FROM A CARD
    export const freezeVirtualCard = createAsyncThunk(
        "freezeVirtualCard",
        async ({cardId}, { rejectWithValue, dispatch, getState }) => {
          try {
            const res = await axios.patch(
              `${baseUrl}/virtual-card/freeze/${cardId}`,
              {},
              {
                headers: {
                  "Content-Type": "application/json",
                  "x-auth-token": getState().auth.token.toString(),
                },
              }
            );
            if (res.status === 200 || res.status === 201) {
              console.log(res);
              cogoToast.success("Virtual Card freezed successfully");
              return res.data;
            }
          } catch (error) {
             if (error.response.status === 401) {
              dispatch({ type: "auth/logout" });
              return rejectWithValue(error.response);
            } else if (error.response.status === 410) {
              cogoToast.error(`${error.response.data.message}`);
              return rejectWithValue(error.response);
            } else {
              cogoToast.error(`${error.response.data.message}`);
              return rejectWithValue(error.response);
            }
          }
        }
      ); 
      
         // ======================================== UNFREEZE FROM A CARD
    export const unFreezeVirtualCard = createAsyncThunk(
        "unFreezeVirtualCard",
        async ({cardId}, { rejectWithValue, dispatch, getState }) => {
          try {
            const res = await axios.patch(
              `${baseUrl}/virtual-card/unfreeze/${cardId}`,
              {},
              {
                headers: {
                  "Content-Type": "application/json",
                  "x-auth-token": getState().auth.token.toString(),
                },
              }
            );
            if (res.status === 200 || res.status === 201) {
              console.log(res);
              cogoToast.success("Virtual Card unfreezed successfully");
              return res.data;
            }
          } catch (error) {
             if (error.response.status === 401) {
              dispatch({ type: "auth/logout" });
              return rejectWithValue(error.response);
            } else if (error.response.status === 410) {
              cogoToast.error(`${error.response.data.message}`);
              return rejectWithValue(error.response);
            } else {
              cogoToast.error(`${error.response.data.message}`);
              return rejectWithValue(error.response);
            }
          }
        }
      ); 

               // ======================================== GET CARD TRANSACTIONS
    export const fetchCardTransactions = createAsyncThunk(
        "fetchCardTransactions",
        async ({cardId, page}, { rejectWithValue, dispatch, getState }) => {
          try {
            const res = await axios.get(
              `${baseUrl}/virtual-card/transactions/${cardId}?page=${page}&page_size=100`,
              {
                headers: {
                  "Content-Type": "application/json",
                  "x-auth-token": getState().auth.token.toString(),
                },
              }
            );
            if (res.status === 200 || res.status === 201) {
              console.log(res);
              return res.data;
            }
          } catch (error) {
             if (error.response.status === 401) {
              dispatch({ type: "auth/logout" });
              return rejectWithValue(error.response);
            } else if (error.response.status === 410) {
              cogoToast.error(`${error.response.data.message}`);
              return rejectWithValue(error.response);
            } else {
              return rejectWithValue(error.response);
            }
          }
        }
      ); 


